module.exports = __webpack_public_path__ + "static/media/brickfield.77c1310a.png";